import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css'; 
import 'select2-theme-bootstrap4/dist/select2-bootstrap.css'; 

import { ensureChartkick } from '../chartkick_config'

function replaceUnassignedInnerFromHtml(htmlString) {
  const doc = new DOMParser().parseFromString(htmlString, 'text/html');
  const next = doc.getElementById('unassigned-participants-inner');
  const cur = document.getElementById('unassigned-participants-inner');
  if (next && cur) {
    cur.replaceWith(next);
  }
}

function updateUnassignedCounter() {
  const mount = document.getElementById('unassigned-participants-mount');
  if (!mount) return;
  const n = mount.querySelectorAll("input[name='participant_ids[]']:checked").length;
  mount.querySelectorAll('.unassigned-counter').forEach((el) => {
    el.textContent = String(n);
  });
}

function initUnassignedParticipantsAjax() {
  const mount = document.getElementById('unassigned-participants-mount');
  if (!mount || mount.dataset.bound === '1') return;
  mount.dataset.bound = '1';
  const baseUrl = mount.dataset.fetchUrl;

  function fetchUnassigned(url) {
    return fetch(url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'text/html',
      },
      credentials: 'same-origin',
    }).then((r) => r.text());
  }

  mount.addEventListener('submit', (e) => {
    if (e.target && e.target.id === 'unassigned-search-form') {
      e.preventDefault();
      const fd = new FormData(e.target);
      const qs = new URLSearchParams(fd).toString();
      const url = qs ? `${baseUrl}?${qs}` : baseUrl;
      fetchUnassigned(url).then((html) => {
        replaceUnassignedInnerFromHtml(html);
        updateUnassignedCounter();
      });
    }
  });

  mount.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!a || !mount.contains(a)) return;
    const inPaginate = a.closest('.unassigned-pagination');
    if (!inPaginate && !a.classList.contains('js-unassigned-reset')) return;
    e.preventDefault();
    fetchUnassigned(a.href).then((html) => {
      replaceUnassignedInnerFromHtml(html);
      if (a.classList.contains('js-unassigned-reset')) {
        const form = document.getElementById('unassigned-search-form');
        if (form) form.reset();
      }
      updateUnassignedCounter();
    });
  });

  $(document).on('change', '#unassigned-check-all', function unassignedCheckAll() {
    const inner = document.getElementById('unassigned-participants-inner');
    if (!inner) return;
    inner.querySelectorAll("input[name='participant_ids[]']").forEach((cb) => {
      cb.checked = this.checked;
    });
    updateUnassignedCounter();
  });

  $(document).on('change', '#unassigned-participants-mount input[name="participant_ids[]"]', () => {
    updateUnassignedCounter();
  });

  updateUnassignedCounter();
}

function updateExamSessionCheckAllState() {
  const master = document.getElementById('exam-session-check-all');
  if (!master) return;
  const rowChecks = document.querySelectorAll('.exam-session-row-check');
  if (rowChecks.length === 0) {
    master.checked = false;
    master.indeterminate = false;
    return;
  }
  const n = Array.from(rowChecks).filter((cb) => cb.checked).length;
  master.checked = n === rowChecks.length;
  master.indeterminate = n > 0 && n < rowChecks.length;
}

function initExamSessionsBulkCheckboxes() {
  $(document).on('change', '#exam-session-check-all', function examSessionCheckAll() {
    const on = this.checked;
    document.querySelectorAll('.exam-session-row-check').forEach((cb) => {
      cb.checked = on;
    });
    updateExamSessionCheckAllState();
  });

  $(document).on('change', '.exam-session-row-check', () => {
    updateExamSessionCheckAllState();
  });
}

function examSessionsFetchTimestampLabel() {
  const d = new Date()
  return (
    'Terakhir sinkron dari server: '
    + d.toLocaleString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    })
  )
}

function updateExamDataFetchStatus() {
  const el = document.getElementById('exam-data-fetch-status')
  if (el) el.textContent = examSessionsFetchTimestampLabel()
}

function initExamSessionsTablePoll() {
  const mount = document.getElementById('exam-sessions-table-mount')
  if (!mount || mount.dataset.tablePollBound === '1') return
  mount.dataset.tablePollBound = '1'
  const baseUrl = mount.dataset.tablePollUrl
  const intervalMs = parseInt(mount.dataset.tablePollMs || '30000', 10)
  if (!baseUrl || !intervalMs) return

  function fetchTableHtml() {
    const qs = window.location.search || ''
    const url = qs ? `${baseUrl}${qs}` : baseUrl
    return fetch(url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'text/html',
      },
      credentials: 'same-origin',
    }).then((r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`)
      return r.text()
    })
  }

  function pollTableFragment() {
    fetchTableHtml()
      .then((html) => {
        mount.innerHTML = html
        updateExamDataFetchStatus()
        updateExamSessionCheckAllState()
      })
      .catch(() => {})
  }

  // Sinkron pertama segera (grafik sudah fetch di awal); lalu sama seperti interval Chartkick (~30 detik).
  pollTableFragment()
  setInterval(pollTableFragment, intervalMs)
}

const EXAMS_OVERVIEW_STORAGE = 'examsOverviewChartIds'

function examsOverviewReadIds() {
  try {
    const raw = sessionStorage.getItem(EXAMS_OVERVIEW_STORAGE)
    const parsed = raw ? JSON.parse(raw) : []
    const arr = Array.isArray(parsed) ? parsed : []
    // Samakan bentuk dengan data-exam-id (string); JSON bisa menyimpan number.
    return [...new Set(arr.map((id) => String(id)))]
  } catch (e) {
    return []
  }
}

function examsOverviewWriteIds(ids) {
  sessionStorage.setItem(EXAMS_OVERVIEW_STORAGE, JSON.stringify(ids))
}

function examsOverviewChartOptions() {
  return {
    height: '300px',
    stacked: false,
    colors: ['#6c757d', '#ffc107', '#28a745'],
    library: {
      plugins: { legend: { display: true, position: 'bottom' } },
      scales: {
        x: { stacked: false },
        y: { stacked: false, beginAtZero: true, ticks: { precision: 0 } },
      },
    },
  }
}

function examOverviewChartkick () {
  return ensureChartkick()
}

function destroyExamOverviewCharts() {
  const Ck = examOverviewChartkick()
  if (!Ck || !Ck.charts) return
  Object.keys(Ck.charts).slice().forEach((key) => {
    if (key.startsWith('examso-')) {
      try {
        Ck.charts[key].destroy()
      } catch (e) {
        /* ignore */
      }
    }
  })
}

function examOverviewHasSeriesData(series) {
  if (!series || !Array.isArray(series)) return false
  return series.some((s) => s && s.data && typeof s.data === 'object' && Object.keys(s.data).length > 0)
}

function renderExamOverviewCharts(payload) {
  const host = document.getElementById('exams-overview-charts-host')
  if (!host) return

  destroyExamOverviewCharts()
  host.innerHTML = ''

  const Ck = examOverviewChartkick()
  if (!Ck || typeof Ck.ColumnChart !== 'function') {
    host.innerHTML = '<p class="text-danger text-center">Grafik tidak tersedia: Chartkick tidak termuat dari pack application. Lakukan hard refresh (Ctrl+F5) atau rebuild assets.</p>'
    return
  }

  if (!payload || payload.error) {
    const msg = (payload && payload.error) ? payload.error : 'Gagal memuat data.'
    host.innerHTML = `<p class="text-muted text-center mb-0">${msg}</p>`
    return
  }

  const opts = examsOverviewChartOptions()

  if (payload.mode === 'merged') {
    const series = payload.series || []
    const h = document.createElement('h6')
    h.className = 'text-center mb-2'
    h.textContent = payload.title || 'Gabungan ujian terpilih'
    host.appendChild(h)
    if (!examOverviewHasSeriesData(series)) {
      const p = document.createElement('p')
      p.className = 'text-muted text-center mb-0'
      p.textContent = 'Belum ada data sesi / lokasi untuk ujian terpilih.'
      host.appendChild(p)
      return
    }
    const div = document.createElement('div')
    div.id = 'examso-merged'
    div.style.height = '320px'
    host.appendChild(div)
    try {
      // eslint-disable-next-line no-new
      new Ck.ColumnChart('examso-merged', series, opts)
    } catch (err) {
      host.innerHTML = `<p class="text-danger text-center">Grafik gagal digambar: ${err.message || err}</p>`
    }
  } else {
    const charts = payload.charts || []
    if (!charts.length) {
      host.innerHTML = '<p class="text-muted text-center mb-0">Tidak ada data.</p>'
      return
    }
    charts.forEach((ch, i) => {
      const wrap = document.createElement('div')
      wrap.className = 'mb-4 pb-3 border-bottom'
      const h = document.createElement('h6')
      h.className = 'text-center mb-2'
      h.textContent = ch.title || String(ch.exam_id)
      wrap.appendChild(h)
      host.appendChild(wrap)

      const series = ch.series || []
      if (!examOverviewHasSeriesData(series)) {
        const p = document.createElement('p')
        p.className = 'text-muted text-center small mb-0'
        p.textContent = 'Belum ada data untuk ujian ini.'
        wrap.appendChild(p)
        return
      }

      const div = document.createElement('div')
      div.id = `examso-sep-${i}`
      div.style.height = '280px'
      wrap.appendChild(div)
      try {
        // eslint-disable-next-line no-new
        new Ck.ColumnChart(`examso-sep-${i}`, series, opts)
      } catch (err) {
        const pe = document.createElement('p')
        pe.className = 'text-danger text-center small'
        pe.textContent = err.message || String(err)
        wrap.appendChild(pe)
      }
    })
  }
}

function updateExamsOverviewFetchStatus() {
  const el = document.getElementById('exams-overview-fetch-status')
  if (!el) return
  el.textContent = examSessionsFetchTimestampLabel()
}

function examsOverviewPayloadSignature(json) {
  if (!json || json.error) return `e:${String(json && json.error)}`
  try {
    return JSON.stringify(json)
  } catch (err) {
    return `x:${Date.now()}`
  }
}

function examOverviewChartsHostHasCharts(host) {
  if (!host) return false
  return host.querySelector('canvas, [id^="examso-"]') != null
}

function initExamsChartsOverview() {
  const root = document.getElementById('exams-charts-overview-root')
  if (!root || root.dataset.overviewBound === '1') return
  root.dataset.overviewBound = '1'

  const urlBase = root.dataset.chartsUrl
  const intervalMs = parseInt(root.dataset.pollMs || '15000', 10)

  function persistFromCheckbox(cb) {
    const id = cb.dataset.examId
    if (!id) return
    let ids = examsOverviewReadIds()
    if (cb.checked) {
      if (!ids.includes(id)) ids.push(id)
    } else {
      ids = ids.filter((x) => x !== id)
    }
    examsOverviewWriteIds(ids)
  }

  function restoreCheckboxes() {
    const ids = examsOverviewReadIds()
    document.querySelectorAll('.js-exam-chart-select').forEach((cb) => {
      if (cb.dataset.examId) cb.checked = ids.includes(cb.dataset.examId)
    })
  }

  function selectedMode() {
    const sel = root.querySelector('.js-exams-chart-mode:checked')
    return sel && sel.value === 'merged' ? 'merged' : 'separate'
  }

  function fetchOverview(opts = {}) {
    const { isPoll = false } = opts
    const ids = examsOverviewReadIds()

    if (ids.length === 0) {
      root.dataset.lastOverviewSig = ''
      destroyExamOverviewCharts()
      const host = document.getElementById('exams-overview-charts-host')
      if (host) {
        const hasRows = root.dataset.hasExamRows === '1'
        const msg = hasRows
          ? '<p class="text-muted text-center mb-0">Centang minimal satu ujian pada kolom <strong>Grafik</strong> di tabel di bawah (scroll ke bawah); atau pakai tombol <strong>Pilih semua di halaman ini</strong>; grafik akan tampil di sini.</p>'
          : '<p class="text-muted text-center mb-0"><strong>Tidak ada baris ujian ditampilkan</strong> (data kosong atau filter pencarian membuat tabel kosong). Reset filter atau pastikan Anda di halaman <kbd>/ujian</kbd>; centang Grafik bisa dilakukan hanya jika tabel ada isinya.</p>'
        host.innerHTML = msg
      }
      const st = document.getElementById('exams-overview-fetch-status')
      if (st) st.textContent = ''
      return Promise.resolve()
    }

    const hostEl = document.getElementById('exams-overview-charts-host')
    const keepChartsVisible = examOverviewChartsHostHasCharts(hostEl)

    // Hindari placeholder "Memuat grafik…" saat polling / refresh cepat — itu mengosongkan area,
    // konten di bawah ikut melompat. Hanya tampilkan loading pada muat pertama (belum ada chart).
    if (!keepChartsVisible) {
      destroyExamOverviewCharts()
      if (hostEl) {
        hostEl.innerHTML = '<p class="text-muted text-center mb-0">Memuat grafik…</p>'
      }
    }

    const params = new URLSearchParams()
    ids.forEach((id) => params.append('exam_ids[]', id))
    params.set('mode', selectedMode())

    return fetch(`${urlBase}?${params.toString()}`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    })
      .then((r) => r.json().catch(() => ({})).then((json) => ({ ok: r.ok, status: r.status, json })))
      .then(({ ok, status, json }) => {
        if (!ok) {
          renderExamOverviewCharts(json.error ? json : { error: `Gagal memuat (${status})` })
          root.dataset.lastOverviewSig = ''
          updateExamsOverviewFetchStatus()
          return
        }
        const sig = examsOverviewPayloadSignature(json)
        if (isPoll && sig === root.dataset.lastOverviewSig) {
          updateExamsOverviewFetchStatus()
          return
        }
        root.dataset.lastOverviewSig = sig
        renderExamOverviewCharts(json)
        updateExamsOverviewFetchStatus()
      })
      .catch(() => {
        if (!isPoll || !keepChartsVisible) {
          renderExamOverviewCharts({ error: 'Tidak dapat menghubungi server.' })
        }
        updateExamsOverviewFetchStatus()
      })
  }

  restoreCheckboxes()
  fetchOverview()
  setInterval(() => {
    if (document.hidden) return
    fetchOverview({ isPoll: true })
  }, intervalMs)

  // Checkbox Grafik ada di tabel di BAWAH blok ini (bukan turunan #exams-charts-overview-root),
  // jadi change tidak bubble ke `root`. Delegasi ke document.
  if (root.dataset.overviewDocChange !== '1') {
    root.dataset.overviewDocChange = '1'
    document.addEventListener('change', (e) => {
      const r = document.getElementById('exams-charts-overview-root')
      if (!r || r.dataset.overviewBound !== '1') return
      const t = e.target
      if (t && t.classList && t.classList.contains('js-exam-chart-select')) {
        persistFromCheckbox(t)
        fetchOverview()
      }
      if (t && t.classList && t.classList.contains('js-exams-chart-mode')) {
        fetchOverview()
      }
    })
  }

  const btnPage = document.getElementById('exams-chart-select-page')
  if (btnPage) {
    btnPage.addEventListener('click', () => {
      let ids = examsOverviewReadIds()
      document.querySelectorAll('.js-exam-chart-select').forEach((cb) => {
        cb.checked = true
        const id = cb.dataset.examId
        if (id && !ids.includes(id)) ids.push(id)
      })
      examsOverviewWriteIds(ids)
      fetchOverview()
    })
  }

  const btnClear = document.getElementById('exams-chart-clear-selection')
  if (btnClear) {
    btnClear.addEventListener('click', () => {
      examsOverviewWriteIds([])
      document.querySelectorAll('.js-exam-chart-select').forEach((cb) => {
        cb.checked = false
      })
      fetchOverview()
    })
  }
}

$(() => {
  $('.select2').select2({
    theme: "bootstrap",
  });
  $('.select2-4').select2({
    theme: "bootstrap4",
  });
  initUnassignedParticipantsAjax();
  initExamSessionsTablePoll();
  initExamSessionsBulkCheckboxes();
  initExamsChartsOverview();

  $(document).on('click', '.btn-ajax', () => {
    $('#editModalBody').html('loading....');
  });
})